import axios from "axios";
import constants from "./../../../../utils/constants";
import { getToken } from "./../../../../utils/Authentication";
const fileDownload = require("js-file-download");

export function getUsersList(data, callback) {
  return function (dispatch) {
    dispatch({ type: "ADMIN_DASHBORDS_LIST" });
    const headers = {
      Authorization: `Bearer ${getToken() || ""}`,
      "Content-Type": "application/json",
    };
    axios
      .post(constants.BASE_URL + `accounts/usermanage/dashboard`, data, {
        headers,
      })
      .then((response) => {
        if (response?.data?.success === 0 && response?.data?.logout === true) {
          sessionStorage.removeItem("token");
          window.sessionStorage.removeItem("userDetails");
          localStorage.removeItem("UserBusinessDetails");
          window.location.href = "/login";
        } else {
          dispatch({
            type: "ADMIN_DASHBORDS_LIST_SUCCESS",
            payload: response.data.data,
          });
        }
      })
      .catch((error) => {
        // console.log(error)
      })
      .finally(() => {
        if (callback) callback();
      });
  };
}

export function getUserTrackingList(data, callback) {
  return function (dispatch) {
    dispatch({ type: "USER_TRACKING_LIST" });
    const headers = {
      Authorization: `Bearer ${getToken() || ""}`,
      "Content-Type": "application/json",
    };
    const config = {
      method: "post",
      url: constants.BASE_URL + `accounts/userslist`,
      headers: headers,
      data: data,
    };
    axios(config)
      .then((response) => {
        if (response?.data?.success === 0 && response?.data?.logout === true) {
          sessionStorage.removeItem("token");
          window.sessionStorage.removeItem("userDetails");
          localStorage.removeItem("UserBusinessDetails");
          window.location.href = "/login";
        } else {
          callback(response.data);
          // dispatch({
          //     type: "USER_TRACKING_LIST_SUCCESS",
          //     payload: response.data.data,
          // });
        }
      })
      .catch((error) => {
        // console.log(error)
      })
      .finally(() => {
        // if (callback) callback();
      });
  };
}

export function getUserTrackingDownload(payload) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "post",
    url: constants.BASE_URL + `accounts/download/userlist`,
    headers: headers,
    data: payload,
    responseType: "arraybuffer",
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
        });
        fileDownload(blob, "tracking.xlsx");
        const data = {
          status: 1,
          message: "Downloaded Successfully",
        };
        return data;
      }
    })
    .catch((error) => {
      const data = {
        status: 0,
        message: "Downloaded Failed",
      };
      return data;
    });
}

export async function inviteUser(data, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "post",
    url: constants.BASE_URL + "users/inviteuser",
    headers: headers,
    data: data,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => {
      // console.log(error)
      return callback(error, null);
    });
}

export async function updateInviteUserDetails(data, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "put",
    url: constants.BASE_URL + "accounts/updateinviteuser",
    headers: headers,
    data: data,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => {
      // console.log(error)
      return callback(error, null);
    });
}

export async function updateUserRole(data, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "put",
    url: constants.BASE_URL + "accounts/updaterole",
    headers: headers,
    data: data,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => {
      // console.log(error)
      return callback(error, null);
    });
}

export async function removeUser(data, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "put",
    url: constants.BASE_URL + "accounts/removeuser",
    headers: headers,
    data: data,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => {
      // console.log(error)
      return callback(error, null);
    });
}

export async function ActivateUser(data, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "put",
    url: constants.BASE_URL + "accounts/update/userstatus",
    headers: headers,
    data: data,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => {
      // console.log(error)
      return callback(error, null);
    });
}

export async function resendInvitation(data, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "post",
    url: constants.BASE_URL + "accounts/resenduser",
    headers: headers,
    data: data,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => {
      // console.log(error)
      return callback(error, null);
    });
}

export async function getDealerFeedSetting(callback) {
  const accountid = window.sessionStorage.getItem("accountId");
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "get",
    url: constants.BASE_URL + `dealerfeeds/accountlist/${accountid}`,
    headers: headers,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => {
      // console.log(error)
      return callback(error, null);
    });
}

export async function getInventorySetting(callback) {
  const accountid = window.sessionStorage.getItem("accountId");
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "get",
    url: constants.BASE_URL + `inventorysetting/accountlist/${accountid}`,
    headers: headers,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => {
      // console.log(error)
      return callback(error, null);
    });
}

export async function createDelaerFeedSetting(data, callback) {
  const userDetails = window.sessionStorage.getItem("userDetails")
    ? JSON.parse(window.sessionStorage.getItem("userDetails"))
    : null;

  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "post",
    url: constants.BASE_URL + `dealerfeeds/create`,
    headers: headers,
    data: data,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => {
      // console.log(error)
      return callback(error, null);
    });
}

export async function createInventorySetting(data, callback) {
  const userDetails = window.sessionStorage.getItem("userDetails")
    ? JSON.parse(window.sessionStorage.getItem("userDetails"))
    : null;

  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "post",
    url: constants.BASE_URL + `inventorysetting/create`,
    headers: headers,
    data: data,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => {
      // console.log(error)
      return callback(error, null);
    });
}

export async function updateDealerFeedSetting(data, callback) {
  const userDetails = window.sessionStorage.getItem("userDetails")
    ? JSON.parse(window.sessionStorage.getItem("userDetails"))
    : null;

  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "put",
    url: constants.BASE_URL + `dealerfeeds/update`,
    headers: headers,
    data: data,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => {
      // console.log(error)
      return callback(error, null);
    });
}

export async function updateInventorySetting(data, callback) {
  const userDetails = window.sessionStorage.getItem("userDetails")
    ? JSON.parse(window.sessionStorage.getItem("userDetails"))
    : null;

  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "put",
    url: constants.BASE_URL + `inventorysetting/update`,
    headers: headers,
    data: data,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => {
      // console.log(error)
      return callback(error, null);
    });
}

export async function getAllAcountList(callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "get",
    url: constants.BASE_URL + `accountsplan/list`,
    headers: headers,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => {
      // console.log(error)
      //   return callback(error, null )
    });
}

export async function getAccountBasedList(accountId, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "get",
    url: constants.BASE_URL + `accountsplan/list/${accountId}`,
    headers: headers,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(response.data);
      }
    })
    .catch((error) => {
      // console.log(error)
      //   return callback(error, null )
    });
}

export async function getclientandsecret(accountId, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "get",
    url: constants.BASE_URL + `exposed/getclient/${accountId}`,
    headers: headers,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(response.data);
      }
    })
    .catch((error) => {
      // console.log(error)
      //   return callback(error, null )
    });
}

export async function generateaccesstoken(data, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "post",
    url: constants.BASE_URL + `v1/tokens`,
    headers: headers,
    data: data,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(response.data);
      }
    })
    .catch((error) => {
      // console.error("Error generating access token:", error);
      //   return callback(error, null )
    });
}

export async function getOwnerBasedList(accountId, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "get",
    url: constants.BASE_URL + `accountsplan/ownerlist/${accountId}`,
    headers: headers,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(response.data);
      }
    })
    .catch((error) => {
      // console.log(error)
      //   return callback(error, null )
    });
}

export async function updateSubscriptionDetails(payload, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "post",
    url: constants.BASE_URL + `accountsplan/create`,
    headers: headers,
    data: payload,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => {
      // console.log(error)
      //   return callback(error, null )
    });
}

export function dealerCommunicationTackingList(data, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  var config = {
    method: "post",
    url: constants.BASE_URL + `dealerinventory/communications/list`,
    headers: headers,
    data: data,
  };
  axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => {
      return callback(error, null);
    });
}
export async function getInvoiceSetting(callback) {
  const accountid = window.sessionStorage.getItem("accountId");
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "get",
    url: `${constants.BASE_URL}invoicesetting/accountlist/${accountid}`,
    headers,
  };

  return axios(config)
    .then((response) => {
      if (response?.data?.success === 0 && response?.data?.logout === true) {
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => callback(error, null));
}

export async function createInvoiceSetting(data, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };

  const config = {
    method: "post",
    url: `${constants.BASE_URL}invoicesetting/create`,
    headers,
    data,
  };

  return axios(config)
    .then((response) => {
      if (response?.data?.success === 0 && response?.data?.logout === true) {
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => callback(error, null));
}
export async function updateInvoiceSetting(data, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };

  const config = {
    method: "put",
    url: `${constants.BASE_URL}invoicesetting/update`,
    headers,
    data,
  };

  return axios(config)
    .then((response) => {
      if (response?.data?.success === 0 && response?.data?.logout === true) {
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => callback(error, null));
}

//QBO settings
export async function getQboSetting(callback) {
  const accountid = window.sessionStorage.getItem("accountId");
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "get",
    url: `${constants.BASE_URL}quickbookSettings/accountlist/${accountid}`,
    headers,
  };

  return axios(config)
    .then((response) => {
      if (response?.data?.success === 0 && response?.data?.logout === true) {
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => callback(error, null));
}

export async function createQboSetting(data, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };

  const config = {
    method: "post",
    url: `${constants.BASE_URL}quickbookSettings/create`,
    headers,
    data,
  };

  return axios(config)
    .then((response) => {
      if (response?.data?.success === 0 && response?.data?.logout === true) {
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => callback(error, null));
}
export async function updateQboSetting(data, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };

  const config = {
    method: "put",
    url: `${constants.BASE_URL}quickbookSettings/update`,
    headers,
    data,
  };

  return axios(config)
    .then((response) => {
      if (response?.data?.success === 0 && response?.data?.logout === true) {
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => callback(error, null));
}

export async function createShopifySettings(data, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };

  const config = {
    method: "post",
    url: constants.BASE_URL + "shopifySettings/create",
    headers,
    data,
  };

  return axios(config)
    .then((response) => {
      if (response?.data?.success === 0 && response.data.logout) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => callback(error, null));
}

export async function getShopifySettings(callback) {
  const accountid = window.sessionStorage.getItem("accountId");
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };

  const config = {
    method: "get",
    url: constants.BASE_URL + `shopifySettings/accountlist/${accountid}`,
    headers,
  };

  return axios(config)
    .then((response) => {
      if (response?.data?.success === 0 && response.data.logout) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => callback(error, null));
}

export async function updateShopifySettings(data, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };

  const config = {
    method: "put",
    url: constants.BASE_URL + "shopifySettings/update",
    headers,
    data,
  };

  return axios(config)
    .then((response) => {
      if (response?.data?.success === 0 && response.data.logout) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => callback(error, null));
}

export async function connectEbay(callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };

  const config = {
    method: "get",
    url: constants.BASE_URL + "ebay/connect",
    headers,
  };

  return axios(config)
    .then((response) => callback(null, response.data))
    .catch((error) => callback(error, null));
}

export async function getEbayStatus(callback) {
  const accountid = window.sessionStorage.getItem("accountId");
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };

  const config = {
    method: "get",
    url: constants.BASE_URL + `ebay/status/${accountid}`,
    headers,
  };

  return axios(config)
    .then((response) => callback(null, response.data))
    .catch((error) => callback(error, null));
}

export async function disconnectEbay(callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };

  const config = {
    method: "post",
    url: constants.BASE_URL + "ebay/disconnect",
    headers,
  };

  return axios(config)
    .then((response) => callback(null, response.data))
    .catch((error) => callback(error, null));
}

export async function createRssFieldSetting(data, callback) {
  const userDetails = window.sessionStorage.getItem("userDetails")
    ? JSON.parse(window.sessionStorage.getItem("userDetails"))
    : null;

  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "post",
    url: constants.BASE_URL + `rss/chronogrid/fields`,
    headers: headers,
    data: data,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => {
      // console.log(error)
      return callback(error, null);
    });
}

export async function getInventorySettingBusiness(callback) {
  const accountid = window.sessionStorage.getItem("accountId");
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "get",
    url: constants.BASE_URL + `rss/businesslist/${accountid}`,
    headers: headers,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => {
      // console.log(error)
      return callback(error, null);
    });
}
export async function getmfaSetting(userid, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };

  const config = {
    method: "get",
    url: constants.BASE_URL + `mfa/mfaenable/lists/${userid}`,
    headers,
  };

  return axios(config)
    .then((response) => callback(null, response.data))
    .catch((error) => callback(error, null));
}
export async function updateMfaSetting(data, callback) {
  const userDetails = window.sessionStorage.getItem("userDetails")
    ? JSON.parse(window.sessionStorage.getItem("userDetails"))
    : null;

  const userid = userDetails?.userid;

  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };

  const payload = {
    ...data,
    userid,
  };

  const config = {
    method: "put",
    url: `${constants.BASE_URL}mfa/savemfa`,
    headers,
    data: payload,
  };

  return axios(config)
    .then((response) => {
      if (response?.data?.success === 0 && response?.data?.logout === true) {
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => callback(error, null));
}
export async function createMfaSetting(data, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };

  const config = {
    method: "post",
    url: `${constants.BASE_URL}mfa/create`,
    headers,
    data,
  };

  return axios(config)
    .then((response) => {
      if (response?.data?.success === 0 && response?.data?.logout === true) {
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => callback(error, null));
}

export async function sendrequestapi(data, token, callback) {
  // console.log("Sending Token:", token);

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  const config = {
    method: "post",
    url: constants.BASE_URL + `v1/products`,
    headers,
    data,
    skipDefaultToken: "yes",
  };

  return axios(config)
    .then((response) => {
      return callback(null, response.data);
    })
    .catch((error) => {
      console.error("API Error:", error);
      callback(error, null);
    });
}
export async function sendinventoryapi(data, token, callback) {
  // console.log("Sending Token:", token);

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  const config = {
    method: "post",
    url: constants.BASE_URL + `v1/inventories`,
    headers,
    data,
    skipDefaultToken: "yes",
  };

  return axios(config)
    .then((response) => {
      return callback(null, response.data);
    })
    .catch((error) => {
      console.error("API Error:", error);
      callback(error, null);
    });
}

export function getBillingStatus(callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  axios
    .get(constants.BASE_URL + "billing/status", { headers })
    .then((response) => { if (callback) callback(null, response.data); })
    .catch((err) => { if (callback) callback(err, null); });
}

export function initBillingSubscription(mode, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  axios
    .post(constants.BASE_URL + "billing/subscribe", { mode }, { headers })
    .then((response) => { if (callback) callback(null, response.data); })
    .catch((err) => { if (callback) callback(err, null); });
}
export function changeBillingPlan(mode, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  axios
    .post(constants.BASE_URL + "billing/subscribe/change", { mode }, { headers })
    .then((response) => { if (callback) callback(null, response.data); })
    .catch((err) => { if (callback) callback(err, null); });
}
export function getBillingPlans(callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  axios
    .get(constants.BASE_URL + "billing/plans", { headers })
    .then((response) => { if (callback) callback(null, response.data); })
    .catch((err) => { if (callback) callback(err, null); });
}

export function cancelBillingPlan(subscriptionId, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  axios
    .delete(constants.BASE_URL + "billing/subscribe", {
      headers,
      data: { subscriptionId },
    })
    .then((response) => { if (callback) callback(null, response.data); })
    .catch((err) => { if (callback) callback(err, null); });
}

export async function createlabelSetting(callback) {
  const accountid = window.sessionStorage.getItem("accountId");
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "get",
    url: constants.BASE_URL + `customlabel/accountlist/${accountid}`,
    headers: headers,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => {
      callback(error, null);
    });
}

export async function savelabelSetting(data, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "post",
    url: constants.BASE_URL + "customlabel/create",
    headers: headers,
    data: data,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => {
      return callback(error, null);
    });
}

export async function updatelabelSetting(data, callback) {
  const headers = {
    Authorization: `Bearer ${getToken() || ""}`,
    "Content-Type": "application/json",
  };
  const config = {
    method: "put",
    url: constants.BASE_URL + "customlabel/update",
    headers: headers,
    data: data,
  };
  return axios(config)
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.success === 0 &&
        response.data.logout === true
      ) {
        sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userDetails");
        localStorage.removeItem("UserBusinessDetails");
        window.location.href = "/login";
      } else {
        return callback(null, response.data);
      }
    })
    .catch((error) => {
      return callback(error, null);
    });
}
